module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/8x8-84a726c3c96a53b66ca093aaf7f6d4ac.svg";